import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Layout guard for admin-only surfaces (ML-ops tools, agent-access RBAC admin). Non-admins are
 * sent to their own landing rather than shown a page whose data endpoints they can't call.
 * Server-side require_admin is the real enforcement; this is the matching client affordance.
 */
const AdminOnly: React.FC = () => {
  const { isAdmin } = useAuth();
  return isAdmin ? <Outlet /> : <Navigate to="/admin" replace />;
};

export default AdminOnly;
